import Vue from 'vue'
import App from './App'
import AppTest from './AppTest'
import router from './router'
import VueScroller from "vue-scroller";
import filter from './service/ServiceFilter';

Vue.use(VueScroller);
Vue.use(filter);
Vue.config.productionTip = false ;
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'

});

//测试入口
// new Vue({
//   el: '#app',
//   router,
//   components: { AppTest },
//   template: '<AppTest/>'
//
// });



// WEBPACK FOOTER //
// ./src/main.js